/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_1_DInputs */

const en_cp_why_1_d = /** @type {(inputs: Cp_Why_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students write pass/fail criteria for every task before an agent may start. A task is done only when verification passes and evidence is uploaded. Overrides need a reason and are logged.`)
};

const id_cp_why_1_d = /** @type {(inputs: Cp_Why_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa menulis kriteria lulus/gagal tiap task sebelum agent boleh mulai. Task hanya selesai bila verifikasi lulus dan bukti terunggah. Override harus beralasan dan tercatat.`)
};

/**
* | output |
* | --- |
* | "Students write pass/fail criteria for every task before an agent may start. A task is done only when verification passes and evidence is uploaded. Overrides ..." |
*
* @param {Cp_Why_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_1_d = /** @type {((inputs?: Cp_Why_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_1_d(inputs)
	return en_cp_why_1_d(inputs)
});